import { SUBMIT_BASE_URL } from './constants';

/**
 * Constructs the external URL used to call the remote survey response submit service.
 *
 * @param instanceId The active session/instance identifier token.
 * @param surveyLanguage Optional language locale string (defaults to 'en').
 * @param surveySubmitted Whether this is a final submit (true) or partial save (false).
 * @returns Fully constructed target submit URL.
 */
export function buildExternalSubmitUrl(
  instanceId: string,
  surveyLanguage = 'en',
  surveySubmitted = true
): string {
  const params = new URLSearchParams({
    instanceId,
    surveySubmitted: surveySubmitted ? 'true' : 'false',
    surveyLanguage,
  });
  return `${SUBMIT_BASE_URL}?${params.toString()}`;
}
